import { apiRequest } from '@/api/http';

// Where a user signed in with an admin-set password must go first.
export const CHANGE_PASSWORD_PATH = '/change-password';

// The route prefix the signed-in user browses under: admin, superadmin,
// parent or employee (faculty). Parents share faculty's account type, so they
// are told apart by the isParent flag the server adds to the session.
export function areaFor(user) {
  const account = user?.user;
  if (Number(account?.usertypeID ?? user?.usertype?.id) === 1) return 'admin';
  if (Number(account?.user_roleID) === 5) return 'superadmin';
  if (account?.isParent) return 'parent';
  return 'employee';
}

// The signed-in user's home page. Someone who still has to replace an
// admin-set password goes there first.
export function homePathFor(user) {
  if (Number(user?.user?.mustChangePassword)) return CHANGE_PASSWORD_PATH;
  return `/${areaFor(user)}/dashboard`;
}

// Loads the user behind the stored token into the store. Returns the user,
// or null (and clears the session) when the token is missing or rejected.
// Network errors are thrown instead, so a brief outage doesn't sign anyone out.
export async function loadSession(store) {
  if (!localStorage.getItem('token')) return null;
  let user = null;
  try {
    user = (await apiRequest('get', '/auth/current_user'))?.userdetail ?? null;
  } catch (e) {
    const status = e?.response?.status;
    if (!status || status >= 500) throw e;
  }
  store.dispatch('setUser', user);
  store.dispatch('setIsAuthenticated', user ? 1 : 0);
  return user;
}

// Stores a fresh login token (from sign-in or a changed password) and loads its user. Returns the user, or null.
export async function signInWithToken(store, token) {
  localStorage.setItem('token', token);
  store.commit('setExpiryDate');
  return loadSession(store);
}

// Signs out on this device (same keys as the global deleteToken mixin).
export function clearSession(store) {
  ['token', 'vuex', '_secure__ls__metadata', 'AssignedModID'].forEach((key) => localStorage.removeItem(key));
  store.dispatch('setUser', null);
  store.dispatch('setEmail', null);
  store.dispatch('setEmp', null);
  store.dispatch('setIsAuthenticated', 0);
}
